import { Calendar, Camera, CheckSquare, ClipboardList, DollarSign, Globe, Key, Megaphone, Package, Settings, ShieldCheck, ShoppingBag, Star, Tag, Ticket, UtensilsCrossed, Users, Wallet } from 'lucide-react';

export const TEAM_ICON_OPTIONS = [
    { value: 'users', label: 'Equipe', Icon: Users },
    { value: 'ticket', label: 'Ingressos', Icon: Ticket },
    { value: 'shopping-bag', label: 'Produtos', Icon: ShoppingBag },
    { value: 'dollar-sign', label: 'Financeiro', Icon: DollarSign },
    { value: 'calendar', label: 'Evento', Icon: Calendar },
    { value: 'package', label: 'Logística', Icon: Package },
    { value: 'check-square', label: 'Check-in', Icon: CheckSquare },
    { value: 'clipboard-list', label: 'Organização', Icon: ClipboardList },
    { value: 'shield-check', label: 'Segurança', Icon: ShieldCheck },
    { value: 'key', label: 'Acesso', Icon: Key },
    { value: 'star', label: 'Destaque', Icon: Star },
    { value: 'camera', label: 'Mídia', Icon: Camera },
    { value: 'megaphone', label: 'Marketing', Icon: Megaphone },
    { value: 'tag', label: 'Promoções', Icon: Tag },
    { value: 'wallet', label: 'Caixa', Icon: Wallet },
    { value: 'globe', label: 'Geral', Icon: Globe },
    { value: 'utensils-crossed', label: 'Alimentação', Icon: UtensilsCrossed },
    { value: 'settings', label: 'Administração', Icon: Settings },
];

export function getTeamIcon(key) {
    return TEAM_ICON_OPTIONS.find(option => option.value === key)?.Icon || Users;
}
